var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.757,
    height: 39,
    viewBox: "0 0 49.757 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_328",
    x: 0,
    y: 0,
    width: 49.757,
    height: 39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_328-2",
    "data-name": "Trac\\xE9 328",
    d: "M-1830.587-1405.519h15.034a.8.8,0,0,1,.767.45.774.774,0,0,1-.109.88q-1.113,1.434-2.227,2.868l-12.653,16.269c-.041.053-.083.106-.126.158a.8.8,0,0,1-1.36-.013q-1.588-2.023-3.161-4.058l-11.682-15.022a3.474,3.474,0,0,1-.221-.3.8.8,0,0,1,.6-1.23,3.553,3.553,0,0,1,.37-.006Z",
    transform: "translate(-1805.69 -1378.52) rotate(180)",
    fill: "#0deaaa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIcon);
export default __webpack_public_path__ + "static/media/top-icon.dab03d1e7376ad43c8f5e557ccee20ae.svg";
export { ForwardRef as ReactComponent };